import cn from 'bem-cn';

import { Stack } from '../../UI';

import { ChallengePrizesSkeleton } from './ChallengePrizes';
import { ChallengeRequirementsSkeleton } from './ChallengeRequirements';

import './ChallengeInfoBody.scss';

const b = cn('challenge-info-body');

export const ChallengeInfoBodySkeleton = () => {
    return (
        <Stack className={b()}>
            <ChallengePrizesSkeleton />
            <ChallengeRequirementsSkeleton />
            <ChallengePrizesSkeleton />
        </Stack>
    );
};
